<template>
  <div v-if="showBanner" class="cookie-banner" :class="{ 'show': showBanner }">
    <div class="container">
      <div class="cookie-content p-3 p-md-4">
        <div class="row align-items-center">
          <div class="col-lg-8">
            <h5 class="mb-2">🍪 Utilizzo dei Cookie</h5>
            <p class="mb-3 mb-lg-0">
              Utilizziamo i cookie per migliorare la tua esperienza sul nostro sito.
              Alcuni cookie sono necessari per il funzionamento del sito, mentre altri
              ci aiutano a migliorare i nostri servizi.
              <router-link to="/cookies" class="text-primary">Maggiori informazioni</router-link>
            </p>
          </div>
          <div class="col-lg-4 text-lg-end">
            <button
              @click="acceptAllCookies"
              class="btn btn-primary me-2 mb-2 mb-lg-0"
            >
              Accetta tutti
            </button>
            <button
              @click="acceptEssentialOnly"
              class="btn btn-outline-secondary mb-2 mb-lg-0"
            >
              Solo essenziali
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookieBanner',
  data() {
    return {
      showBanner: false
    }
  },
  mounted() {
    // Controlla se l'utente ha già fatto una scelta
    this.showBanner = !localStorage.getItem('cookieConsent')
  },
  methods: {
    acceptAllCookies() {
      localStorage.setItem('cookieConsent', 'all')
      this.showBanner = false
      // Evento per Google Analytics o altri servizi
      this.$emit('cookies-accepted', 'all')
    },
    acceptEssentialOnly() {
      localStorage.setItem('cookieConsent', 'essential')
      this.showBanner = false
      // Evento per disabilitare servizi non essenziali
      this.$emit('cookies-accepted', 'essential')
    }
  }
}
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  transform: translateY(100%);
  transition: transform 0.3s ease-in-out;
}

.cookie-banner.show {
  transform: translateY(0);
}

.cookie-content {
  max-width: 1200px;
  margin: 0 auto;
}

.btn-primary {
  background: #219ebc;
  border-color: #219ebc;
}

.btn-primary:hover {
  background: #023047;
  border-color: #023047;
}

.btn-outline-secondary {
  color: #666;
  border-color: #666;
}

.btn-outline-secondary:hover {
  background: #f8f9fa;
  color: #333;
}

@media (max-width: 991.98px) {
  .cookie-banner {
    padding: 1rem;
  }
}
</style>
